import type { SchemaColumn } from '@cli-types/core-engine/schema.js'

export function buildColumnMeta(column: SchemaColumn, extra?: Record<string, string>): string {
  const props: Record<string, string> = { ...extra }
  if (column.align && column.align !== 'left') {
    props.align = column.align
  }
  const entries = Object.entries(props)
  if (entries.length === 0) return ''
  const inner = entries.map(([k, v]) => `${k}: '${v}'`).join(', ')
  return `meta: { ${inner} },\n    `
}
